export const getSelectedLink = (menuItems: any, linkPathname: string) => {
  const split = linkPathname.split('/')
  const currentPathname = split[split.length - 1]
  return menuItems.find((link: any) => `/${currentPathname}` === link.link)
}
